/**
 * Matomo tracking utility
 */

import { fetchMatomoConfig } from '../services/apiService';

// Initialize Matomo tracking
export const initMatomo = async () => {
  try {
    // Fetch Matomo configuration from the backend
    const config = await fetchMatomoConfig();
    
    // If URL or siteId is missing, don't initialize Matomo
    if (!config.url || !config.siteId) {
      console.warn('Matomo configuration is incomplete. Tracking disabled.');
      return false;
    }

    // Create _paq array if it doesn't exist
    window._paq = window._paq || [];

    // Require cookie consent before setting any cookies (GDPR)
    window._paq.push(['requireCookieConsent']);

    // Set up basic tracking
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);

    // Set up the tracker
    window._paq.push(['setTrackerUrl', `${config.url}matomo.php`]);
    window._paq.push(['setSiteId', config.siteId]);
    
    // Add Matomo script to the document
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `${config.url}matomo.js`;
    
    // Append the script to the head
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
    
    console.log('Matomo tracking initialized successfully');
    return true;
  } catch (error) {
    console.error('Error initializing Matomo:', error);
    return false;
  }
};

// Track page view
export const trackPageView = (pageName) => {
  if (window._paq) {
    if (pageName) {
      window._paq.push(['setCustomUrl', pageName]);
    }
    window._paq.push(['trackPageView']);
  }
};

// Track event
export const trackEvent = (category, action, name, value) => {
  if (window._paq) {
    window._paq.push(['trackEvent', category, action, name, value]);
  }
};

// Grant cookie consent (user accepted cookies)
export const grantCookieConsent = () => {
  if (window._paq) {
    window._paq.push(['setCookieConsentGiven']);
  }
};

// Revoke cookie consent (user rejected cookies)
export const revokeCookieConsent = () => {
  if (window._paq) {
    window._paq.push(['forgetCookieConsent']);
  }
};